import {FormatNumberOptions, IntlShape} from 'react-intl';

type FormatOptionsType = FormatNumberOptions;


export function formatCurrency(
  intl: IntlShape,
  value: number | string,
  currency: string,
  options?: FormatOptionsType,
): string {
  return intl.formatNumber(
    typeof value === 'string' ? parseFloat(value) : value,
    {
      style: 'currency',
      currency,
      ...options,
    },
  );
}
